import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row dashboard__hero" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  key: 1,
  class: "px-sm-2 px-xl-4 py-2_5"
}
const _hoisted_4 = { class: "row mb-2" }
const _hoisted_5 = { class: "col d-flex flex-column flex-md-row justify-content-between align-items-md-center" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-md-9" }
const _hoisted_8 = { class: "col-12 col-md-3 mt-2 mt-md-0" }
const _hoisted_9 = { class: "row row-cols-2 row-cols-md-1" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "text-type-5-bold text-label" }
const _hoisted_12 = { class: "text-type-1" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "dashboard__hero__stat" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "dashboard__hero__stat" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "row row-cols-1 row-cols-md-2 dashboard__grid mt-2_5 px-sm-2 px-xl-4" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = {
  key: 1,
  class: "dashboard__card p-1_5"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col d-flex align-items-center" }
const _hoisted_27 = { class: "text-type-2-bold" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "dashboard__card__stat" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "dashboard__card__stat" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "col" }
const _hoisted_38 = {
  key: 1,
  class: "dashboard__card p-1_5"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col d-flex align-items-center" }
const _hoisted_43 = { class: "text-type-1-bold" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "dashboard__card__stat" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "dashboard__card__stat" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_som_icon_chevron_right = _resolveComponent("som-icon-chevron-right")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_som_icon_caret_up = _resolveComponent("som-icon-caret-up")!
  const _component_som_icon_caret_down = _resolveComponent("som-icon-caret-down")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.unemployRate == '')
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-type-2-bold mb-1 mb-md-0" }, "Unemployment Rate", -1)),
                  _createVNode(_component_router_link, {
                    to: `/unemployment/Unemployment`,
                    class: "btn btn-link dashboard__hero__cta"
                  }, {
                    default: _withCtx(() => [
                      _cache[0] || (_cache[0] = _createTextVNode("View Details ")),
                      _createVNode(_component_som_icon_chevron_right, { size: "md" })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_LineChart, {
                    metricData: _ctx.unemployData,
                    dataLabels: _ctx.unemployDataLabels,
                    dataProps: _ctx.unemployDataProps,
                    options: _ctx.unemployOptions,
                    dateLabel: _ctx.unemployMetric.dateProp,
                    class: "dashboard__hero__chart"
                  }, null, 8, ["metricData", "dataLabels", "dataProps", "options", "dateLabel"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, [
                        _cache[2] || (_cache[2] = _createTextVNode(" Unemployment Rate")),
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.unemployRate) + "%", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, [
                        _cache[4] || (_cache[4] = _createTextVNode(" Monthly Change:")),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                        (Number(_ctx.unemployMonthChange) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                              _createVNode(_component_som_icon_caret_up, { color: "danger" })
                            ]))
                          : _createCommentVNode("", true),
                        (Number(_ctx.unemployMonthChange) < 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _createVNode(_component_som_icon_caret_down, { color: "success" })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.unemployMonthChange), 1)
                      ]),
                      _createElementVNode("p", _hoisted_17, [
                        _cache[6] || (_cache[6] = _createTextVNode(" Yearly Change:")),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        (Number(_ctx.unemployYearChange) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                              _createVNode(_component_som_icon_caret_up, { color: "danger" })
                            ]))
                          : _createCommentVNode("", true),
                        (Number(_ctx.unemployYearChange) < 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                              _createVNode(_component_som_icon_caret_down, { color: "success" })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.unemployYearChange), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        (_ctx.unemployRate == '')
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("p", { class: "section-title" }, "Payroll Jobs")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_LineChart, {
                    metricData: _ctx.payrollJobsData,
                    dataLabels: _ctx.payrollJobsDataLabels,
                    dataProps: _ctx.payrollJobsDataProps,
                    options: _ctx.payrollJobsOptions,
                    dateLabel: _ctx.payrollJobsMetric.dateProp,
                    isDashboardSubChart: true,
                    lineColorOverride: 2,
                    class: "dashboard__card__chart"
                  }, null, 8, ["metricData", "dataLabels", "dataProps", "options", "dateLabel"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.payrollJobsRate), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", _hoisted_29, [
                    _cache[8] || (_cache[8] = _createTextVNode(" Monthly Change:")),
                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                    (_ctx.payrollJobsMonthChangeNum > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                          _createVNode(_component_som_icon_caret_up, { color: "success" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.payrollJobsMonthChangeNum < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                          _createVNode(_component_som_icon_caret_down, { color: "danger" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.payrollJobsMonthChange), 1)
                  ]),
                  _createElementVNode("p", _hoisted_32, [
                    _cache[10] || (_cache[10] = _createTextVNode(" Yearly Change:")),
                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                    (_ctx.payrollJobsYearChangeNum > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                          _createVNode(_component_som_icon_caret_up, { color: "success" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.payrollJobsYearChangeNum < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                          _createVNode(_component_som_icon_caret_down, { color: "danger" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.payrollJobsYearChange), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_router_link, {
                    to: `/laborForce/PayrollJobs`,
                    class: "btn btn-link dashboard__card__cta stretched-link"
                  }, {
                    default: _withCtx(() => [
                      _cache[12] || (_cache[12] = _createTextVNode("View Details ")),
                      _createVNode(_component_som_icon_chevron_right)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_37, [
        (_ctx.laborForceRate == '')
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col" }, [
                  _createElementVNode("p", { class: "section-title" }, "Labor Force Participation")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_LineChart, {
                    metricData: _ctx.laborForceData,
                    dataLabels: _ctx.laborForceDataLabels,
                    dataProps: _ctx.laborForceDataProps,
                    options: _ctx.laborForceOptions,
                    dateLabel: _ctx.laborForceMetric.dateProp,
                    isDashboardSubChart: true,
                    lineColorOverride: 3,
                    class: "dashboard__card__chart"
                  }, null, 8, ["metricData", "dataLabels", "dataProps", "options", "dateLabel"])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.laborForceRate) + "%", 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("p", _hoisted_45, [
                    _cache[14] || (_cache[14] = _createTextVNode(" Monthly Change:")),
                    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                    (Number(_ctx.laborForceMonthChange) > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                          _createVNode(_component_som_icon_caret_up, { color: "success" })
                        ]))
                      : _createCommentVNode("", true),
                    (Number(_ctx.laborForceMonthChange) < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                          _createVNode(_component_som_icon_caret_down, { color: "danger" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.laborForceMonthChange), 1)
                  ]),
                  _createElementVNode("p", _hoisted_48, [
                    _cache[16] || (_cache[16] = _createTextVNode(" Yearly Change:")),
                    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                    (Number(_ctx.laborForceYearChange) > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                          _createVNode(_component_som_icon_caret_up, { color: "success" })
                        ]))
                      : _createCommentVNode("", true),
                    (Number(_ctx.laborForceYearChange) < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                          _createVNode(_component_som_icon_caret_down, { color: "danger" })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.laborForceYearChange), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_router_link, {
                    to: `/laborForce/LaborForceParticipation`,
                    class: "btn btn-link dashboard__card__cta"
                  }, {
                    default: _withCtx(() => [
                      _cache[18] || (_cache[18] = _createTextVNode("View Details ")),
                      _createVNode(_component_som_icon_chevron_right)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
      ])
    ])
  ], 64))
}